var $export = require('./_export')
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', {create: require('./_object-create')});


//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/library/modules/es6.object.create.js
// module id = 441
// module chunks = 2 92